import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { NotificationProvider } from "../NotificationContext";

const PrivateRoute = ({ children }) => {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const userData = useSelector((state) => state.auth.userData);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

   
     //find user id and role from userData
    const userId = userData?.id;
    const userRole = userData?.role.toLowerCase() ?? " ";

    return (
        <NotificationProvider userId={userId} userRole={userRole}>
            {children}
        </NotificationProvider>
    );
};

export default PrivateRoute;




// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children }) => {
//     const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
//     return isAuthenticated ? children : <Navigate to="/login" />
// }

// export default PrivateRoute



// // src/routes/PrivateRoute.js
// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "../AuthContext";

// const PrivateRoute = ({ children }) => {
//     const { isVerified, loading } = useAuth();

//     if (loading) {
//         return (
//             <div className="d-flex justify-content-center align-items-center" style={{ width: "100%", height: "100vh" }}>
//                 <div className="spinner-border text-primary " role="status">
//                     <span class="visually-hidden">Loading...</span>
//                 </div>
//             </div>
//         )
//     }

//     return isVerified ? children : <Navigate to="/" />;
// };

// export default PrivateRoute;
